import React from 'react'

import ProfileCollectionSidescroll from 'components/ProfileCollectionSidescroll/ProfileCollectionSidescroll'
import Wrapper from 'components/Wrapper/Wrapper'
import useProfileInCollections from 'hooks/useProfileInCollections'

function RelatedProfileCollections({
  profileSlug,
  noMoreLink = false,
  limit = undefined,
  title = undefined,
}) {
  const { loading, error, profile = {} } = useProfileInCollections(profileSlug)
  if (loading || error || !profile) return null
  let { inProfileCollections = [] } = profile
  if (limit && inProfileCollections.length > limit) {
    inProfileCollections = inProfileCollections.slice(0, limit)
  }

  return (
    <Wrapper edgeToEdge style={{ marginTop: 20 }}>
      {inProfileCollections.map((pc) => (
        <ProfileCollectionSidescroll
          key={pc.id}
          title={title || pc.publicCmsItem?.content?.title || ' '}
          profileCollection={pc}
          loading={loading}
          noMoreLink={noMoreLink}
        />
      ))}
    </Wrapper>
  )
}
export default RelatedProfileCollections
